import React, { Component, useDebugValue } from 'react';
import { Link } from 'react-router';
import { Row, Col } from 'reactstrap';
import { leaseTypeDrpdwn } from '../../../../constants';
import {checkString} from '../../../../formValidator'
import { jetStreamInstance } from '../../../Leases';
import { FieldCol, FieldDate, FieldGroup, FieldInput, FieldLabel, FieldSelect, FieldTextarea } from '../../../../applications/contracts/Elements';
export default class EditReturnCndCard extends Component{
  constructor(props){
    super(props);
    this.state = {
      returnCndCard: {},
      error: {}
    }
  }
  componentDidMount(){
    this.updateHdState(this.props.returnCndCard);
  }
  updateHdState = (returnCndCard) => {
    let data = Object.assign({}, returnCndCard);
    this.setState({
        returnCndCard: data
    });
  }
  updateForm = (type, value) => {
    if(['redelivery_location','actual_delivery_date','redelivery_comment','fit_operational_region','return_with_original_sl_no',
         'c_check_at_lease_expiry','governing_law','livery','redelivery_date','premature_redelivery'].includes(type)){
      this.setState(prevState => ({
        returnCndCard: {
          ...prevState.returnCndCard,
          titan_extra_fields: {
            ...prevState.returnCndCard?.titan_extra_fields,
            [type]: value,
          },
        },
      }));
    }
  }
  updateDeliveryCndCard = (e) => {
    e.preventDefault();
    const titan_extra_fields = { ...this.state.returnCndCard.titan_extra_fields };
    this.props.updateDeliveryCndCard({ titan_extra_fields })
  }
  render(){
    const { type} = this.props;
    const { returnCndCard } = this.state;
      return(
        <form onSubmit={(e) => this.updateDeliveryCndCard(e)}>
          <div style={{ height: (window.innerHeight - 157) + 'px', overflow:'auto',marginBottom:'60px' }}>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Fit Operational Region </FieldLabel>
                  <FieldInput
                    value={returnCndCard?.titan_extra_fields?.fit_operational_region || ''}
                    type={type}
                    keyParam="fit_operational_region"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
            <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Livery</FieldLabel>
                  <FieldInput
                    value={returnCndCard?.titan_extra_fields?.livery || ''}
                    type={type}
                    keyParam="livery"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">C Check at Lease Expiry </FieldLabel>
                  <FieldInput
                    value={returnCndCard?.titan_extra_fields?.c_check_at_lease_expiry || ''}
                    type={type}
                    keyParam="c_check_at_lease_expiry"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Must return with original engine serial numbers</FieldLabel>
                  <FieldSelect
                    placeholder='Select Yes/No'
                    keyParam="return_with_original_sl_no"
                    value={returnCndCard?.titan_extra_fields?.return_with_original_sl_no || ''}
                    type={type}
                    options={[{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }]}
                    updateField={this.updateForm}
                    labelKey='label'
                    valueKey='value'
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
            <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Redelivery Location</FieldLabel>
                  <FieldInput
                    value={returnCndCard?.titan_extra_fields?.redelivery_location || ''}
                    type={type}
                    keyParam="redelivery_location"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Actual Redelivery Date</FieldLabel>
                  <FieldDate
                    value={returnCndCard?.titan_extra_fields?.redelivery_date}
                    type={type}
                    keyParam="redelivery_date"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
            <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Redelivery Comment</FieldLabel>
                  <FieldTextarea
                    value={returnCndCard?.titan_extra_fields?.redelivery_comment || ''}
                    type={type}
                    keyParam="redelivery_comment"
                    updateField={this.updateForm}
                    style={{height:'100px'}}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Premature Redelivery </FieldLabel>
                  <FieldInput
                    value={returnCndCard?.titan_extra_fields?.premature_redelivery || ''}
                    type={type}
                    keyParam="premature_redelivery"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
         </div>
         <div className="submit-block">
           <input type="submit" className="primary-btn" value="Save Changes"/>
           <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
         </div>
       </form>
      )
  }
}
